import Http from "./http";

export const getReleaseDocListAPI = (data) => {
    return Http.post("admin/getDocumentList", data);
};

export const updateReleaseDocumentStatusAPI = (data) => {
    return Http.post("admin/createOrUpdateDocument", data);
};
